"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _round2 = _interopRequireDefault(require("lodash/round"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SummaryTable = function SummaryTable(props) {
  var columns = [{
    name: 'group.label',
    label: 'Group',
    sort: true
  }, {
    name: 'childRoles.participantSummary.youthPre',
    label: 'Youth Pre',
    className: 'text-center',
    render: function render(_ref) {
      var value = _ref.value;
      return (0, _round2["default"])(value, 1);
    }
  }, {
    name: 'childRoles.participantSummary.youthPost',
    label: 'Youth Post',
    className: 'text-center',
    render: function render(_ref2) {
      var value = _ref2.value;
      return (0, _round2["default"])(value, 1);
    }
  }, {
    name: 'childRoles.participantSummary.caregiverPre',
    label: 'Caregiver Pre',
    className: 'text-center',
    render: function render(_ref3) {
      var value = _ref3.value;
      return (0, _round2["default"])(value, 1);
    }
  }, {
    name: 'childRoles.participantSummary.caregiverPost',
    label: 'Caregiver Post',
    className: 'text-center',
    render: function render(_ref4) {
      var value = _ref4.value;
      return (0, _round2["default"])(value, 1);
    }
  }];
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    rowKey: "group.groupId",
    graphqlVariables: {
      groupIds: props.filters.groupIds,
      startDate: props.filters.startDate,
      endDate: props.filters.endDate
    },
    query: props.query,
    columns: columns
    // render={tableProps => console.log(tableProps)}
  });
};
var _default = exports["default"] = SummaryTable;